import "core-js/modules/es.array.concat";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.replace";
import _objectSpread from "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import IconShare from '@tencent/vft-component/IconShare';
import { setShare } from '@vip-activity/business/pageSetting';
import env from '@tencent/vft-common/env';
import pop from '@/mixin/pop';
import config from '@/config';
import { cutStrWithEmoji } from '@/util';
export default {
  props: {
    shareInfo: {}
  },
  mixins: [pop],
  components: {
    IconShare: IconShare,
    CloudSealCard: function CloudSealCard() {
      return import('@tencent/cloud-seal-card');
    }
  },
  watch: {
    value: function value(val) {
      setShare(val ? _objectSpread(_objectSpread({}, this.shareCfg), {}, {
        link: this.params.shareUrl.replace(/qr\./, 'pg.')
      }) : this.shareCfg, this.userService);
    }
  },
  data: function data() {
    return {
      env: env,
      index: 0,
      key: Date.now(),
      base64: ''
    };
  },
  computed: {
    shareCfg: function shareCfg() {
      var _ref = this.shareInfo || {},
          mode = _ref.mode;

      var _this$setting = this.setting,
          门票炫耀分享 = _this$setting.门票炫耀分享,
          门票赠送分享 = _this$setting.门票赠送分享,
          门票领取分享 = _this$setting.门票领取分享,
          门票买自己分享 = _this$setting.门票买自己分享;
      var shareSetting = null;

      if (!this.value) {
        shareSetting = window.pageSetting;
      } else if (mode === 'xy') {
        shareSetting = 门票炫耀分享;
      } else if (mode === 'lq') {
        shareSetting = 门票领取分享;
      } else if (mode === 'buy') {
        shareSetting = 门票买自己分享;
      } else {
        shareSetting = 门票赠送分享;
      }

      var _shareSetting = shareSetting,
          分享标题 = _shareSetting.分享标题,
          分享描述 = _shareSetting.分享描述,
          分享朋友圈标题 = _shareSetting.分享朋友圈标题,
          分享图 = _shareSetting.分享图,
          分享链接 = _shareSetting.分享链接;
      return {
        timeLineTitle: 分享朋友圈标题,
        imgUrl: 分享图,
        title: 分享标题,
        desc: 分享描述,
        link: 分享链接
      };
    },
    showChange: function showChange() {
      var _this$setting$;

      return ((_this$setting$ = this.setting.分享图切换配置) === null || _this$setting$ === void 0 ? void 0 : _this$setting$.length) > 1;
    },
    params: function params() {
      var _this$userService = this.userService,
          nick = _this$userService.nick,
          headurl = _this$userService.headurl;
      var vipIcon = this.vipService.vipIcon;
      var params = {};

      if (this.shareInfo.cardType === 'props') {
        Object.assign(params, {
          level: vipIcon,
          nick: cutStrWithEmoji(nick, 12),
          headImg: headurl,
          shareUrl: "".concat(config.shareLink, "?ptag=qr.props")
        });
      } else {
        var _this$shareInfo = this.shareInfo,
            mode = _this$shareInfo.mode,
            token = _this$shareInfo.token,
            label = _this$shareInfo.label,
            _this$shareInfo$starN = _this$shareInfo.starName,
            starName = _this$shareInfo$starN === void 0 ? '' : _this$shareInfo$starN,
            _this$shareInfo$starP = _this$shareInfo.starProps,
            starProps = _this$shareInfo$starP === void 0 ? '' : _this$shareInfo$starP;
        var shareImgArr = this.setting.分享图切换配置; // 获取分享图切换配置

        var _shareImgArr = shareImgArr[this.index % shareImgArr.length],
            背景图 = _shareImgArr.背景图,
            歌词 = _shareImgArr.歌词;
        var _this$setting$2 = this.setting.海报分享配置;
        _this$setting$2 = _this$setting$2 === void 0 ? {} : _this$setting$2;
        var 购买提示图 = _this$setting$2.购买提示图,
            赠送提示图 = _this$setting$2.赠送提示图;
        Object.assign(params, {
          mode: mode,
          level: vipIcon,
          nick: cutStrWithEmoji(nick, 12),
          posterSrc: 背景图,
          lyrics: 歌词,
          headImg: headurl,
          shareUrl: "".concat(config.shareLink, "?ptag=qr.").concat(mode),
          label: label,
          starName: starName,
          starProps: starProps,
          promptImg: mode === 'zs' ? 赠送提示图 : 购买提示图
        });

        if (mode === 'zs') {
          params.shareUrl = "".concat(params.shareUrl, "&token=").concat(token);
        }

        params.qrUrl = params.shareUrl;
      }

      console.log(params);
      return params;
    },
    sealCardId: function sealCardId() {
      return 'l5Dk0e9EPd';
    }
  },
  methods: {
    success: function success(img) {
      this.base64 = img;
      console.log('card img success.', Date.now() - this.key);
    },
    changeCard: function changeCard() {
      this.index += 1;
      this.key = Date.now();
    },
    closeP: function closeP() {
      this.base64 = '';
      this.$emit('close');
      this.$emit('input', false);
    }
  }
};